import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import SignUp from './SignUp'

import InputField from 'src/components/InputField'
import MoneyField from 'src/components/MoneyField'
import UploadProfilePicture from 'src/profile_picture/UploadProfilePicture'

const maxLength = 750

const Form = ({
  logged_in, organizer_create, disable_form, loading, toggleSignIn, inputProps,
  handleSubmit, imageUpload, profile_picture, omni, children
}) => {
  const messageProps = inputProps('fundraiser_landing_page.p2p_custom_message')

  // Only render PP UI if there isn't one on file; profile_picture is from Rails
  const profilePictureMarkup = !profile_picture && !disable_form &&
    <UploadProfilePicture
      {...inputProps('profile_picture')}
      imageUpload={imageUpload}
      label="Profile picture (optional)"
      center
    />

  return (
    <form noValidate onSubmit={handleSubmit}>
      {
        (!logged_in || organizer_create)
      ? <SignUp
          inputProps={inputProps}
          toggleSignIn={toggleSignIn}
          organizer_create={organizer_create}
          omni={omni}
        >
          {profilePictureMarkup}
        </SignUp>
      : profilePictureMarkup
      }

      <h2 className="text-center">Fundraiser Details</h2>

      <InputField
        {...messageProps}
        type="textarea"
        rows="4"
        label="Share your why"
        placeholder="Speak from the heart"
        labelClass="mb-2"
        disabled={disable_form}
        hint={
          <span>
            <span className={
              messageProps.value.length > maxLength ? 'text-danger' : null
            }>
              {messageProps.value.length}
            </span>/{maxLength} characters
          </span>
        }
      />

      <InputField
        {...inputProps('goal')}
        label="Fundraiser goal (optional)"
        type={MoneyField}
        exponent={0}
        disabled={disable_form}
        hint="Leave blank or zero if you don’t want a goal"
      />

      <div className="text-center">
        <button
          className="btn btn-primary"
          disabled={loading || disable_form}
        >
          {
            loading
            ? <span>
                <FontAwesomeIcon icon="cog" spin className="me-2" />
                Launching Fundraiser...
              </span>
            : 'Launch Fundraiser'
          }
        </button>
      </div>

      {children}
    </form>
  )
}

export default Form
